import React from "react";
import "./AddButtonComponent.scss";
import PropTypes from "prop-types";

function AddButtonComponent({ title, handleAddButtonClick }) {
  return (
    <button
      tabIndex="0"
      title={title}
      className="add-button-wrapper"
      onClick={handleAddButtonClick}
    >
      +
    </button>
  );
}

AddButtonComponent.propTypes = {
  title: PropTypes.string,
  handleAddButtonClick: PropTypes.func,
};

export default AddButtonComponent;
